import { axios } from "lib/Init";

export default class Geocoder {
    constructor() {
    };

    geocode(criteria, callback) {
        
        axios.post('/api/location/geocode', {
            criteria
        })
        .then(response => {
            this._didFetchGeocode(response.data.address, callback) 
            });
    }

    _didFetchGeocode(data, callback) {
        const address = data;
        const results = [];

        // Format to match Google's Place API response
        address.geometry = {
            location: {
                lat: () => (address.lat),
                lng: () => (address.lng),
            }
        };
        results.push(address);
        
        callback(results, 'OK');
    }
}